import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { css } from "styled-components";

Object.assign(productCountStyles, {
    ...productCountStyles,
    wrapper: {
        css: css`
            margin-top: 10px;
            margin-bottom: 20px;
        `,
    },
    countText: {
        fontFamily: "Neuron",
        weight: 600,
        css: css`
            white-space: nowrap;
        `,
    },
    itemsText: {
        size: 16,
        fontFamily: "Neuron",
    },
});
